import { toast } from "../../../../../core/helpers/message-helper";
import { Row, Col, Button, Form, Spinner } from "reactstrap";
import { useEffect, useState } from "react";
import InputController from "../../../../../core/ui/components/InputController";
import SelectController from "../../../../../core/ui/components/SelectController";
import ContentWrapper from "../../../../../core/ui/components/Layout/ContentWrapper";
import {
    crearSolicitud,
    selectLugaresPorSede,
} from "../../../services/solicitudes-soporte-service";
import { useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { obtenerParametrosPorTipos } from "../../../../Parametros/services/parametros-service";

const SolicitudesSoporte = () => {
    const [lugares, setLugares] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [tiposPrioridad, setTiposPrioridad] = useState([]);
    const { sede, tipoSolicitud } = useOutletContext();
    const navigate = useNavigate();

    const REQUIRED_RULE = {
        required: "Este campo es requerido",
    };

    useEffect(async () => {
        if (tipoSolicitud == null) {
            navigate("/solicitudes/ciudades");
        }
        const resp = await selectLugaresPorSede(sede.id);
        if (!resp.status) return toast.error(resp.message);
        setLugares(resp.data);
    }, []);

    useEffect(async () => {
        const resp = await obtenerParametrosPorTipos(
            "estados_solicitudes_soporte"
        );
        if (!resp.status) return toast.error(resp.message);

        const tiposPrioridad = resp.data.map((tipoPrioridad) => {
            return {
                value: tipoPrioridad.id,
                label: tipoPrioridad.nombre,
            };
        });

        setTiposPrioridad(tiposPrioridad);
    }, []);

    const onCreateSolicitud = async (solicitudes) => {
        const solicitud = new FormData(
            document.getElementById("formSolicitudesSoporte")
        );
        solicitud.set("area_has_tipo_solicitud_id", tipoSolicitud.id);
        solicitud.set("lugar_id", solicitudes.lugar_id.value);
        solicitud.set(
            "parametro_prioridad_id",
            solicitudes.parametro_prioridad_id.value
        );
        setCargando(true);
        const resp = await crearSolicitud(solicitud);
        setCargando(false);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        navigate("/solicitudes/ciudades");
    };

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm();

    return (
        <Form
            onSubmit={handleSubmit(onCreateSolicitud)}
            id="formSolicitudesSoporte"
        >
            <ContentWrapper>
                <div className="content-heading">
                    <div>
                        MESA DE AYUDA / Solicitudes De Soporte
                    </div>
                </div>
                <div className="row">
                    <Row className="col-md-8 col-md-offset-3">
                        <Col sm={6}>
                            <InputController
                                control={control}
                                errors={errors}
                                label="Asunto"
                                name="asunto"
                                rules={REQUIRED_RULE}
                                placeholder="Asunto"
                            />
                            <SelectController
                                label="Ubicación"
                                name="lugar_id"
                                errors={errors}
                                control={control}
                                rules={REQUIRED_RULE}
                                options={lugares.map((lugar) => {
                                    return {
                                        label: lugar.nombre,
                                        value: lugar.id,
                                    };
                                })}
                            />
                        </Col>
                        <Col sm={6}>
                            <SelectController
                                label="Prioridad"
                                options={tiposPrioridad}
                                errors={errors}
                                control={control}
                                rules={REQUIRED_RULE}
                                name="parametro_prioridad_id"
                                placeholder="Prioridad"
                            />
                            <InputController
                                type="file"
                                multiple
                                label="Adjunto"
                                errors={errors}
                                control={control}
                                name="adjunto[]"
                            />
                        </Col>
                        <Col sm={12}>
                            <InputController
                                type="textarea"
                                control={control}
                                errors={errors}
                                label="Descripcion"
                                name="descripcion"
                                rules={REQUIRED_RULE}
                                placeholder="Descripcion"
                            />
                        </Col>
                        <Col sm={6}></Col>
                        <div className="d-flex justify-content-end">
                            <Button
                                className="mr-2"
                                color="secondary"
                                key="save"
                                type="submit"
                                disabled={cargando}
                            >
                                {cargando ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <i className="fas fa-plus mr-2"></i>
                                )}
                                <span>Guardar</span>
                            </Button>
                            <Button
                                color="primary"
                                key="close"
                                /* onClick={() => cancelar()} */
                            >
                                <i className="fas fa-trash mr-2"></i>
                                Cancelar
                            </Button>
                        </div>
                    </Row>
                </div>
            </ContentWrapper>
        </Form>
    );
};

export default SolicitudesSoporte;
